import { Col, Typography } from "antd";
import AppAnimate from "@lib/components/AppComponents/AppAnimate";
import AppRowContainer from "@lib/components/AppComponents/AppRowContainer";
import AppsContainer from "@lib/components/AppComponents/AppsContainer";
import { SelectedCustomerSelectBox } from "@lib/components/MiniComponents/Others";
import MiniInfoCard from "@lib/components/MiniComponents/Dashboard/MiniInfoCard";
import { FaFilter } from "react-icons/fa";
import { blue } from "@ant-design/colors";
import { useIntl } from "react-intl";
import {
  LeadBlockchainPaymentsMiniCard,
  WalletAddressMiniCard,
  WhiteLabelLeadMiniCard,
} from "@app/admin/dashboards/components/MiniCards";
import { AppContext } from "@lib/types";
import {
  SharedSendBytePaymentList,
  SharedSendBytePaymentRequestList,
} from "@app/shared";
import { StyledFlexDiv } from "@lib/components/StyledComponents";
import { Link } from "react-router-dom";
import { ROUTES } from "@lib/constants";
import { useTypedSelector } from "@lib/redux";

export default function CustomerLeadDashboard() {
  const { messages } = useIntl();
  const { selectedCustomer } = useTypedSelector((state) => state.cache);

  return (
    <AppsContainer
      title={messages["common.dashboard"] as string}
      fullView
      cardStyle={{
        background: "transparent",
        boxShadow: "none",
      }}
    >
      <AppAnimate animation="transition.slideUpIn" delay={200}>
        <AppRowContainer>
          <Col xs={24} md={12} lg={6} xl={6}>
            <WhiteLabelLeadMiniCard cardProps={{ borderFull: true }} />
          </Col>
          <Col xs={24} md={12} lg={6} xl={6}>
            <WalletAddressMiniCard cardProps={{ borderFull: true }} />
          </Col>
          <Col xs={24} md={12} lg={6} xl={6}>
            <LeadBlockchainPaymentsMiniCard cardProps={{ borderFull: true }} />
          </Col>
          <Col xs={24} md={12} lg={6} xl={6}>
            <MiniInfoCard
              data={{
                icon: <FaFilter />,
                color: blue[5],
                desc: <SelectedCustomerSelectBox />,
              }}
              cardProps={{ borderFull: true }}
            />
          </Col>

          <Col xs={24} md={24} lg={24}>
            <SharedSendBytePaymentRequestList
              withoutContainer
              height={230}
              context={AppContext.CUSTOMER_LEAD}
              queryParams={{
                filter: [
                  ...(selectedCustomer?.id
                    ? [`customerId||$eq||${selectedCustomer.id}`]
                    : []),
                ],
                join: ["customer", "customerUser", "sendByteWalletAddress"],
                sort: "createdAt,DESC",
              }}
              tableProps={{
                columnsConfig: {
                  noFilter: true,
                  noSort: true,
                  noPagination: true,
                  // noAction: true,
                  hiddenColumns: ["updatedAt", "updatedBy"],
                },
                header: {
                  title: (
                    <StyledFlexDiv style={{ gap: 10 }}>
                      <Typography.Text strong>
                        {messages["common.sendBytePaymentRequests"] as string}
                      </Typography.Text>

                      <Link
                        to={
                          ROUTES.ADMIN.CUSTOMER_LEAD.BLOCKCHAIN_PAYMENT_REQUESTS
                            .LIST
                        }
                      >
                        {messages["common.viewAll"] as string}
                      </Link>
                    </StyledFlexDiv>
                  ),
                },
              }}
            />
          </Col>

          <Col xs={24} md={24} lg={24}>
            <SharedSendBytePaymentList
              withoutContainer
              height={280}
              context={AppContext.CUSTOMER_LEAD}
              queryParams={{
                filter: [
                  ...(selectedCustomer?.id
                    ? [`customerId||$eq||${selectedCustomer.id}`]
                    : []),
                ],
                join: ["customerUser", "customer", "sendByteWalletAddress"],
                sort: "createdAt,DESC",
              }}
              tableProps={{
                columnsConfig: {
                  noFilter: true,
                  noSort: true,
                  noPagination: true,
                  hiddenColumns: ["updatedAt", "updatedBy"],
                },
                header: {
                  title: (
                    <StyledFlexDiv style={{ gap: 10 }}>
                      <Typography.Text strong>
                        {messages["common.sendBytePayments"] as string}
                      </Typography.Text>

                      <Link
                        to={ROUTES.ADMIN.CUSTOMER_LEAD.BLOCKCHAIN_PAYMENTS.LIST}
                      >
                        {messages["common.viewAll"] as string}
                      </Link>
                    </StyledFlexDiv>
                  ),
                },
              }}
            />
          </Col>
        </AppRowContainer>
      </AppAnimate>
    </AppsContainer>
  );
}
